import { IsNotEmpty, IsNumberString } from 'class-validator';

export class RouteParameterTypeDTO {

    @IsNotEmpty()
    @IsNumberString()
    type: string;

}
